import { ApiResult } from 'src/Libs/api'
import { SmartMeterGatewayModel } from '../model'
import { AuthFetchWithResponse } from 'src/Types/api'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { SmartMeterGateway } from './dto'
import { fromSmartMeterGatewayDtoToModelTransformer, fromSmartMeterGatewayFormToDtoTransformer } from '../transformers'
import { SmartMeterGatewayFormModel } from '../transformers/from-smart-meter-gateway-form-to-dto.transformer'

/**
 * Get data for smart meter gateway
 */
export const fetchSmartMeterGateway = async (
  storageId: string | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<SmartMeterGatewayModel, AuthFetchError | Error>> => {
  if (!storageId) {
    return new ApiResult<SmartMeterGatewayModel, AuthFetchError | Error>(null, true, new Error('No StorageId provided'))
  }

  try {
    const response = await authFetch<SmartMeterGateway>({
      path: `storages/${storageId}/smart-meter-gateway`,
      method: 'GET',
      endpoint: process.env.REACT_APP_API_ENDPOINT,
    })
    if (response.status === StatusCodes.OK) {
      const smartMeterGateway = fromSmartMeterGatewayDtoToModelTransformer(response.data)
      return new ApiResult<SmartMeterGatewayModel, AuthFetchError | Error>(smartMeterGateway, false)
    }
    return new ApiResult<SmartMeterGatewayModel, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<SmartMeterGatewayModel>(error)
  }
}

/**
 * Set the settings values for smart meter gateway
 */
export const updateSmartMeterGateway = async (
  storageId: string,
  value: SmartMeterGatewayFormModel,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<void, AuthFetchError | Error>> => {
  try {
    const payload = fromSmartMeterGatewayFormToDtoTransformer(value)

    const response = await authFetch<void>({
      path: `storages/${storageId}/smart-meter-gateway`,
      method: 'POST',
      endpoint: process.env.REACT_APP_API_ENDPOINT,
      payload,
    })
    if (response.status === StatusCodes.OK) {
      return new ApiResult<void, AuthFetchError | Error>()
    }
    return new ApiResult<void, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<void>(error)
  }
}

/**
 * Trust the SKI for smart meter gateway
 */
export const trustSmartMeterGatewaySki = async (
  storageId: string | undefined,
  skiToTrust: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<void, AuthFetchError | Error>> => {
  if (!storageId) {
    return new ApiResult<void, AuthFetchError | Error>(null, true, new Error('No StorageId provided'))
  }

  try {
    const response = await authFetch<void>({
      path: `storages/${storageId}/smart-meter-gateway/trust`,
      method: 'PUT',
      endpoint: process.env.REACT_APP_API_ENDPOINT,
      payload: { smgwSki: skiToTrust },
    })

    if (response.status === StatusCodes.NO_CONTENT) {
      return new ApiResult<void, AuthFetchError | Error>()
    }

    return new ApiResult<void, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<void>(error)
  }
}
